document.addEventListener("DOMContentLoaded", function () {
    let button = document.querySelector(".donation-button");
    let popup = document.querySelector(".donation-popup");
    let textElement = document.querySelector(".donation-text");
    let infoLink = document.querySelector(".donation-info-link");

    if (!button || !popup || !textElement || !infoLink) return;

    let currentLang = Shopify.locale || "en"; 

    let translations = {
  en: {
    button_text: "Colibri donates 10%",
    popup_text: "Every purchase helps a child in need. We donate 10% of each order.",
    image_alt: "Donation Image",
    more_info: "More info →"
  },
  fr: {
    button_text: "Colibri donne 10%",
    popup_text: "Chaque achat aide un enfant dans le besoin. Nous donnons 10% de chaque commande.",
    image_alt: "Image de don",
    more_info: "Plus d'infos →"
  },
  nl: {
    button_text: "Colibri doneert 10%",
    popup_text: "Elke aankoop helpt een kind in nood. We doneren 10% van elke bestelling.",
    image_alt: "Donatie afbeelding",
    more_info: "Meer info →"
  },
  ru: {
    button_text: "Colibri жертвует 10%",
    popup_text: "Каждая покупка помогает ребенку в нужде. Мы жертвуем 10% с каждого заказа.",
    image_alt: "Изображение пожертвования",
    more_info: "Подробнее →"
  },
  de: {
    button_text: "Colibri spendet 10%",
    popup_text: "Jeder Einkauf hilft einem bedürftigen Kind. Wir spenden 10% jeder Bestellung.",
    image_alt: "Spendenbild",
    more_info: "Mehr Infos →"
  }
};


    const langData = translations[currentLang] || translations.en;

    // Устанавливаем текст кнопки без изображения
    button.textContent = langData.button_text;
    textElement.textContent = langData.popup_text;
    popup.querySelector("img").alt = langData.image_alt;
    infoLink.textContent = langData.more_info;

    let manualOpen = false;

    button.addEventListener("mouseenter", () => {
        if (!manualOpen) {
            popup.style.opacity = "1";
            popup.style.visibility = "visible";
        }
    });

    button.addEventListener("mouseleave", (e) => {
        setTimeout(() => {
            if (!popup.matches(":hover") && !manualOpen) {
                popup.style.opacity = "0";
                popup.style.visibility = "hidden";
            }
        }, 100);
    });

    popup.addEventListener("mouseleave", () => {
        if (!manualOpen) {
            popup.style.opacity = "0";
            popup.style.visibility = "hidden";
        }
    });

    button.addEventListener("click", (e) => {
        e.stopPropagation();
        manualOpen = true;
        popup.style.opacity = "1";
        popup.style.visibility = "visible";
    });

    document.addEventListener("click", function (e) {
        if (!popup.contains(e.target) && !button.contains(e.target)) {
            manualOpen = false;
            popup.style.opacity = "0";
            popup.style.visibility = "hidden";
        }
    });
});